import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-flat-layout-wrapper',
  templateUrl: './flat-layout-wrapper.component.html',
  styleUrls: ['./flat-layout-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlatLayoutWrapperComponent {
  constructor() {}
}
